import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/bottomNavOffers/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { BOTTOM_NAV_OFFERS_EXPERIENCE } from 'constants/TestTarget';

const showBottomNavOffersSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === BOTTOM_NAV_OFFERS_EXPERIENCE.CHALLENGER_ONE,
    challengerTwo: testReady && experience === BOTTOM_NAV_OFFERS_EXPERIENCE.CHALLENGER_TWO,
    challengerThree: testReady && experience === BOTTOM_NAV_OFFERS_EXPERIENCE.CHALLENGER_THREE,
    challengerFour: testReady && experience === BOTTOM_NAV_OFFERS_EXPERIENCE.CHALLENGER_FOUR,
    challengerFive: testReady && experience === BOTTOM_NAV_OFFERS_EXPERIENCE.CHALLENGER_FIVE
}));

export { showBottomNavOffersSelector };
